import Helpers from "../../../../../Site/gulp/scripts/typescript/modules/helpers";

export default class Article {

	private header: HTMLElement;
	private image: HTMLElement;
	private aside: HTMLElement;

	constructor() {

		const articleElement = document.querySelector('.js-article');

		if (!articleElement) return;

		this.header = document.querySelector('.js-article-header');
		this.image = document.querySelector('.js-article-image');
		this.aside = document.querySelector('.js-article-aside');

		if (!this.header || !this.image || !this.aside) return;

		this.positionAside();
		const debouncedPositionAside = Helpers.debounce(() => this.positionAside(), 250);
		window.addEventListener('resize', debouncedPositionAside);

	}

	private positionAside() {

		const height = this.header.getBoundingClientRect().height;
		this.aside.style.paddingTop = height + 'px';

	}

}
